import { render, staticRenderFns } from "./KvmAppInfo.vue?vue&type=template&id=2304e294&scoped=true&"
import script from "./KvmAppInfo.vue?vue&type=script&lang=js&"
export * from "./KvmAppInfo.vue?vue&type=script&lang=js&"
import style0 from "./KvmAppInfo.vue?vue&type=style&index=0&id=2304e294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304e294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2304e294')) {
      api.createRecord('2304e294', component.options)
    } else {
      api.reload('2304e294', component.options)
    }
    module.hot.accept("./KvmAppInfo.vue?vue&type=template&id=2304e294&scoped=true&", function () {
      api.rerender('2304e294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmAppInfo.vue"
export default component.exports